import React, { useContext, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import PsContext from "../../context";
import {
  getFileLiveUrl,
  MOB_ICONS,
  momentDate,
  upperCase,
  yearBySem,
} from "../../utils";
import Header from "../header";

const StudentMyProfile = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState([]);
  const [timeTable, setTimeTable] = useState([]);

  const userPhoto = () => {
    let gender = upperCase(context.user.gender);
    let path = context.user.profile_photo;
    if (path && path.length > 5) {
      return getFileLiveUrl(path);
    }

    if (gender == "MALE") return MOB_ICONS.MAN_256;
    else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
    return MOB_ICONS.NO_USER_250;
  };

  return (
    <>
      <Header title="Profile" backAction={true} />
      <div className="container-sm">
        <div className="profile-container" style={{ height: "150px" }}></div>
        <div
          className="d-flex justify-content-center align-content-center"
          style={{ marginTop: "-75px" }}
        >
          <img
            className=""
            style={{
              width: "100%",
              maxWidth: "170px",
              height: "190px",
              borderRadius: "50%",
              border: "4px solid white",
              zIndex: "1",
            }}
            src={userPhoto()}
          />
        </div>
        {/* <div className="text-center mt-3 fw-bolder fs-1">
          {context.user.name} {context.user.initial}
        </div> */}
        <div className="" data-aos="zoom-in">
          <div className="container-sm py-md-3 ">
            <div className="py-2"></div>
            <Card>
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Personal Information
              </Card.Header>
              <Card.Body>
                <Row className="">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Name <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={`${context.user.name} ${
                        context.user.initial || ""
                      }`}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Reg. No <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={
                        context.user.registerno || context.user.admissionno
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Programee <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={`${yearBySem(context.user.semester)} - ${
                        context.user.degree_name
                      } ${context.user.course_name}`}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      Gender <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={upperCase(context.user.gender)}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4} sm={4} xs={3}>
                    <label>
                      DOB <span className="text-danger"></span>
                    </label>
                  </Col>
                  <Col md={8} sm={8} xs={9}>
                    <Form.Control
                      type="text"
                      size="sm"
                      className="fw-bold"
                      value={momentDate(context.user.dob, "DD-MMM-YYYY")}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="px-2">
              {/*<Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Community <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={upperCase(context.user.community_name)}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Caste <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={upperCase(context.user.caste)}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Religion <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={upperCase(context.user.religion_name)}
              />
            </Col>
  </Row>*/}

              {/*<div className="bg-blue-100 text-primary fw-bold p-2 form-title-card mt-2">
            Contact
          </div>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Mobile <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={upperCase(context.user.mobile)}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Email <span className="text-danger"></span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={context.user.email}
              />
            </Col>
</Row>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return (
    <>
      <Header title="Profile" backAction={true} />

      <div
        className="d-flex justify-content-center profile_card_bg align-content-center"
        style={{ height: "290px" }}
        // style={{ marginTop: "-60px" }}
      >
        <div className="p-0">
          <img
            className="p-2 mt-3"
            style={{ width: "100%", maxWidth: "180px" }}
            src={userPhoto()}
          />
        </div>
      </div>
    </>
  );
  return (
    <>
      <Header title="Profile" backAction={true} />
    </>
  );
};
export default StudentMyProfile;
